const climateImpact = {
    pageName: 'Environmental Impact',
    inputs: [
        
    ]
};

export default climateImpact;